/** Explain an unlinked profile without suggesting an automatic company choice. */
export function unlinkedCompanyProfileNotice(profileCount: number): string {
  return profileCount === 0
    ? 'No company profile linked. Create a company profile in your organisation and link it before generating forms or cover letters.'
    : `No company profile linked. Choose the correct profile from your organisation (${profileCount} ${profileCount === 1 ? 'profile available' : 'profiles available'}) before generating forms or cover letters. No profile is selected automatically.`;
}
